// extracted by mini-css-extract-plugin
export default {"container":"rating_container__3n3ry","count":"rating_count__SFB7g","icon":"rating_icon__eJWK9"};